import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { ClipsFeed, ClipUpload } from '../components/Clips';
import { Plus } from 'lucide-react';

const ClipsPage = () => {
  const { isAuthenticated } = useAuth();
  const [showUpload, setShowUpload] = useState(false);

  return (
    <div className="relative">
      <ClipsFeed />
      
      {/* Upload FAB - only for authenticated users */}
      {isAuthenticated && (
        <button
          onClick={() => setShowUpload(true)}
          className="fixed bottom-24 right-4 w-14 h-14 bg-purple-600 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-700 transition z-40"
          data-testid="upload-clip-btn"
        >
          <Plus className="w-7 h-7 text-white" />
        </button>
      )}

      {/* Upload Modal */}
      {showUpload && (
        <ClipUpload 
          onClose={() => setShowUpload(false)}
          onSuccess={() => {
            setShowUpload(false);
            window.location.reload(); // Refresh to show new clip
          }}
        />
      )}
    </div>
  );
};

export default ClipsPage;
